import { useContext } from 'react';
import ThemeContext from '../../store/theme-context';

const Card = (props) => {
    const theme = useContext(ThemeContext);
    return ( 
        <div className="card card-hover" onClick={props.onClick} style={{background: theme.currentTheme.background, color: theme.currentTheme.foreground, borderColor:theme.currentTheme.borderColor, boxShadow:theme.currentTheme.boxShadow}}>
            {props.children}
        </div>
     );
}
 
export default Card;